import { useState, useCallback } from 'react';

const STAGGER_DELAY = 100; // 100ms delay between each image load

export function useImageLoader() {
  const [loadedImages, setLoadedImages] = useState<Set<string>>(new Set());

  const staggerLoadImages = useCallback((drawings: any[]) => {
    drawings.forEach((drawing, index) => {
      if (drawing.preview_image) {
        setTimeout(() => {
          const img = new Image();
          img.onload = () => {
            setLoadedImages(prev => new Set([...prev, drawing.id]));
          };
          img.src = drawing.preview_image || '';
          console.log(`Starting to load image ${index + 1} with delay ${index * STAGGER_DELAY}ms`);
        }, index * STAGGER_DELAY);
      }
    });
  }, []);

  return {
    loadedImages,
    setLoadedImages,
    staggerLoadImages
  };
}